import script from "./ProceDure.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceDure.vue?vue&type=script&setup=true&lang=js"

import "./ProceDure.vue?vue&type=style&index=0&id=4cd9c92a&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd9c92a"]])

export default __exports__